import palette from '../palette';

export default {
  styleOverrides: {
    input: {
      '&::placeholder': {
        opacity: 1,
        color: palette.text.secondary,
      },
    },
  },
};
